import React from "react"
import avatar from "avatar/poppy-sad.svg"

const PoppySad = (props) => <img src={avatar} className="avatar" {...props} />

export default PoppySad
